import http from '@/plugins/http';

export default (params) => new Promise((res, rej) => {
  const updateInfo = new FormData();
  updateInfo.append('name', params.form.name);
  updateInfo.append('company_size', params.form.size);
  updateInfo.append('business_sector', params.form.activity);
  updateInfo.append('description', params.form.description ? params.form.description : ' ');
  if (params.form.avatarUrl) {
    updateInfo.append('logo', params.form.avatarUrl);
  }

  if (params.form.accountant.email) {
    updateInfo.append('accountant_email_list', params.form.accountant.email);
  }

  if (params.form.siret) {
    updateInfo.append('siret', params.form.siret);
  }
  updateInfo.append('billing_address', JSON.stringify({
    city: params.form.city,
    street: params.form.street,
    country_code: params.form.pays,
    zip_code: params.form.postalcode,
  }));
  http.post(`/v3/customers/${params.id}`, updateInfo)
    .then((response) => {
      res(response);
    })
    .catch((error) => {
      rej(error);
    });
});
